import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[adsptAccordionCollapsedContent]' })
export class AccordionCollapsedContentDirective {
  constructor(readonly tr: TemplateRef<any>) {}
}
